import { FC, ReactNode } from "react";
import { Route as DOMRoute, Redirect } from "react-router-dom";
import { getTokens } from "../shared/utils";

interface Props {
  component: ReactNode;
  needAuth: boolean;
  exact: boolean;
  path: string;
  redirectTo?: string;
}

const Route: FC<Props> = ({
  component: Component,
  needAuth,
  redirectTo,
  ...rest
}) => {
  const tokens = getTokens();

  return (
    <DOMRoute
      {...rest}
      render={(routeProps: any) => {
        return needAuth && !tokens.token ? (
          <Redirect
            to={{
              pathname: redirectTo ? redirectTo : "/",
              state: { referrer: routeProps.location },
            }}
          />
        ) : tokens.token && routeProps.history.location.pathname === "/" ? (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: { referrer: routeProps.location },
            }}
          />
        ) : (
          // @ts-ignore
          <Component {...routeProps} {...rest} />
        );
      }}
    />
  );
};

export default Route;
